import {Component} from '@angular/core';

import { LoginService, UserService} from '../../shared';
import {TrackingAction, TrackingCategory} from '../../shared/model/tracking/tracking.enum';
import {TrackingService} from '../../shared/services/tracking.service';

@Component({
    selector: 'jhi-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: [
        'navbar.scss'
    ]
})
export class NavbarComponent {

    isNavbarCollapsed: boolean;

    constructor(
        private loginService: LoginService,
        public userService: UserService,
        private trackingService: TrackingService
    ) {
        this.collapseNavbar();
    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }

    logout() {
        this.collapseNavbar();
        this.loginService.logout();
    }

    isAuthenticated() {
        return this.userService.authenticated;
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

  trackCliquer() {
    this._track(TrackingAction.CLIQUER);
  }

  private _track(action: TrackingAction) {
    this.trackingService.trackEvent({
      action,
      properties: {
        category: TrackingCategory.HEADER,
        name: 'Aide'
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/navbar/navbar.component.ts